export const MAIN_CLASS_NAME = 'elma365-tool-table';
export const SEARCH_CLASS_NAME = `${MAIN_CLASS_NAME}__search`;
export const CHECKBOX_CLASS_NAME = `${MAIN_CLASS_NAME}__checkbox`;
export const COMPONENT_CLASS_NAME = `${MAIN_CLASS_NAME}__component`;
export const LABEL_CLASS_NAME = `${CHECKBOX_CLASS_NAME}__label`;

export const TOOL_PAGE_SIZE = 250;
export const TOOL_ICON_SIZE = 20;
